<script>
  import Modal from '@components/general/modal.svelte'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import { useForm } from '@inertiajs/svelte'
  import { Send } from 'lucide-svelte'

  let { open = $bindable(false), feedback, title = "Give feedback", label = "Your opinion", record, onClose, onSuccess } = $props()

  let formId = "feedback-form"

  let isUpdate = $derived(feedback?.id)
  let recordLabel = $derived(record?.type?.replace(/([A-Z])/g, ' $1').trim())

  let sentimentOptions = [
    { value: "", label: "" },
    { value: "neutral", label: "Neutral - I neither strongly like nor dislike this" },
    { value: "positive", label: "Positive - I liked this" },
    { value: "negative", label: "Negative - I didn't like this" },
  ]

  const form = $derived(useForm({
    message: feedback?.message || "",
    sentiment: feedback?.sentiment || "",
  }))

  function handleCreate() {
    $form.transform(data => ({
      ...data,
      feedbackable_id: record.id,
      feedbackable_type: record.type,
    }))
    $form.post(`/feedbacks`, { onSuccess })
  }

  function handleUpdate() {
    $form.patch(`/feedbacks/${feedback.id}`, { onSuccess })
  }

  function handleSubmit(e) {
    e.preventDefault()
    isUpdate ? handleUpdate() : handleCreate()
  }

</script>

<Modal bind:open {title} {onClose}>

  <Form.Element {form} id={formId} onsubmit={handleSubmit}>

    <Form.Items>

      <!-- The record this feedback is for -->
      {#if record?.name}
        <Form.Item name="record" label={recordLabel} value={record.name} cols={12} disabled />
      {/if}

      <Form.Item name="message" bind:value={$form.message} label="Message *" type="textarea" hint="Let us know what you think!" cols={12} required />

      <Form.Item name="sentiment" bind:value={$form.sentiment} {label} hint="How do you feel about this? (optional)" cols={12} options={sentimentOptions} />
    
    </Form.Items>
    
  </Form.Element>
  
  {#snippet footer()}
    <Button type="submit" form={formId} text={isUpdate ? "Update feedback" : "Send feedback"} variant="submit" Icon={Send} loading={$form.processing} />
  {/snippet}

</Modal>